import React from 'react'
import { FaChevronRight, FaEdit } from 'react-icons/fa'

const Modelli = ({ modelli, onSelModello }) => {
  
  return <div className='d-flex flex-row align-items-center justify-content-center flex-wrap'>{modelli && modelli.map(modello =>
    <div style={{width: '100%', maxWidth: '400px'}} className='animate__animated animate__flipInX'>
      <div className={`menu-questionario menu-item m-2 border rounded-pill px-4 bg-white d-flex flex-column align-items-start justify-content-center questionario'}`} onClick={() => onSelModello(modello)}>
        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
          <span className='m-2 text-primary'><strong>{modello.DESCRIZIONE}</strong></span>
          <div style={{ width: '30px' }}>
            <>            
              <h4 className='m-0 icona'><FaEdit color="var(--bs-primary)" /></h4>
              <h2 className='m-0 arrow'><FaChevronRight color="var(--bs-primary)" /></h2>              
            </>
          </div>
        </div>
      </div>
    </div>    
  )}
  </div>
}

export default Modelli